package br.com.heyagenda.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider

private val DarkColorScheme = darkColorScheme(
    primary = DarkAuraColors.primaryButtonBg,
    onPrimary = DarkAuraColors.primaryButtonText,
    secondary = DarkAuraColors.emerald,
    onSecondary = DarkAuraColors.textPrimary,
    background = DarkAuraColors.background,
    onBackground = DarkAuraColors.textPrimary,
    surface = DarkAuraColors.cardSurface,
    onSurface = DarkAuraColors.textPrimary,
    surfaceVariant = DarkAuraColors.cardSurfaceHover,
    onSurfaceVariant = DarkAuraColors.textSecondary,
    outline = DarkAuraColors.borderSubtle
)

private val LightColorScheme = lightColorScheme(
    primary = LightAuraColors.primaryButtonBg,
    onPrimary = LightAuraColors.primaryButtonText,
    secondary = LightAuraColors.emerald,
    onSecondary = LightAuraColors.textPrimary,
    background = LightAuraColors.background,
    onBackground = LightAuraColors.textPrimary,
    surface = LightAuraColors.cardSurface,
    onSurface = LightAuraColors.textPrimary,
    surfaceVariant = LightAuraColors.cardSurfaceHover,
    onSurfaceVariant = LightAuraColors.textSecondary,
    outline = LightAuraColors.borderSubtle
)

@Composable
fun HeyAgendaTheme(
    forceDark: Boolean? = null,
    content: @Composable () -> Unit
) {
    val auraColors = DarkAuraColors
    val colorScheme = DarkColorScheme

    CompositionLocalProvider(LocalAuraColors provides auraColors) {
        MaterialTheme(
            colorScheme = colorScheme,
            typography = AuraTypography,
            content = content
        )
    }
}
